import { useState, useEffect } from "react";

const UseIsSmallScreen = (breakpoint = 640) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < breakpoint);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < breakpoint);
    window.addEventListener("resize", handleResize);

    // Check screen size initially in case it was loaded in a small viewport
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isSmallScreen;
};

export default UseIsSmallScreen;
